export const Confessions = [
    {
        "id" : 1,
        "name" : "Shivam",
        "date" : "20-10-24",
        "icon" : "🤫",
        "confession" : "Ladka ho ya Ladki sabka katega !!"
    },
    {
        "id" : 2,
        "name" : "Solid boyzz",
        "date" : "24-10-24",
        "icon" : "🫣",
        "confession" : "Bafana raa saai tujhe oo harjai"
    },





    
]